<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row margin-b">
                    <div class="col-md-12">
                        <app-sub-header title="Merchant Directory"></app-sub-header>

                        <div class="display">
                            <div>
                                <input #movieSearchInput type="search" placeholder="Search" class="form-control">
                            </div>
                            <div class="margin-l">
                                <div routerLink="/merchant-directory/filter"> <i class="fas fa-sliders-h"></i></div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <app-no-results-found *ngIf="arrList?.length == 0 && loading" hide ='merchant' title='Merchants'>
                        </app-no-results-found>


                        <div *ngIf="!loading">
                            <div *ngFor="let props of arr">
                                <app-card-skelton></app-card-skelton>
                            </div>
                        </div>
                        <div class="col-md-12" *ngIf="loading">
                            <div *ngFor="let props of (objArr | paginate
        : {
            itemsPerPage: pageSize,
            currentPage: pageNo,
            totalItems: totalItems
          })">
                                <app-alert-card size=2 [showtext]=true [data]="props" title="Claim" [others]="false"
                                    [sideButton]="true" [route]="route" [changeStatus]="status"
                                    (getBlock)="getBlockMerchant($event)" (getReport)="getReportMerchant($event)"
                                    (getUnblock)="getunblockMerchant($event)">
                                </app-alert-card>
                            </div>
                        </div>
                        <div *ngIf="loading" class="col-md-12" style="text-align: center;">
                            <pagination-controls class="col s12 col-md-offset-3 my-pagination"
                                *ngIf="objArr?.length > 0 " (pageChange)="page = getClaimList($event)"
                                directionLinks="true" autoHide="false" responsive="true" previousLabel="Previous"
                                nextLabel="Next" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                                screenReaderCurrentLabel="You're on page">
                            </pagination-controls>
                        </div>
                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
